import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="about-area-1 space">
      <div className="about1-shape-img shape-mockup">
        <img
          className="about1-shape-img-1 spin"
          src="assets/img/normal/about_shape1-2.svg"
          alt="LealChapayPintura.com"
        />
        <img
          className="about1-shape-img-2 spin2"
          src="assets/img/normal/about_shape1-1.svg"
          alt="LealChapayPintura.com"
        />
      </div>
      <div className="container">
        <div className="row align-items-center justify-content-between flex-row-reverse">
          <div className="col-xxl-12">
            <div className="about-content-wrap">
              <div className="title-area me-xl-50 mb-30">
                <span className="sub-title">Política de Privacidad</span>
                <div className="sec-text">
                  <p>
                    <strong>Información básica sobre Protección de Datos</strong>
                  </p>
                  <p>
                    <strong>Responsable:</strong> Leal Chapa y Pintura SL
                  </p>
                  <p>
                    <strong>Finalidad:</strong> Prestación de servicios online, Gestión de usuarios web, Comunicaciones comerciales relacionadas con nuestros servicios
                  </p>
                  <p>
                    <strong>Legitimación:</strong> Consentimiento expreso e interés legítimo
                  </p>
                  <p>
                    <strong>Destinatarios:</strong> No se ceden datos a terceros, salvo obligación legal
                  </p>
                  <p>
                    <strong>Derechos:</strong> Acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional
                  </p>
                  <p>
                    <strong>Información adicional:</strong> Puede consultar la información adicional y detallada sobre Protección de Datos en las cláusulas anexas que se encuentran en{" "}
                    <a
                      href="http://www.lealchapaypintura.com/privacidad"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.lealchapaypintura.com/privacidad
                    </a>
                  </p>
                  <br />
                  <p>
                    En Leal Chapa y Pintura SLU trabajamos para ofrecerte a través de nuestros productos y servicios la mejor experiencia posible. En algunos casos, es necesario recabar información para conseguirlo. Nos importa tu privacidad y creemos que debemos ser transparentes al respecto.
                  </p>
                  <p>
                    Por ello, y a efectos de lo previsto en el REGLAMENTO (UE) 2016/679 DEL PARLAMENTO EUROPEO Y DEL CONSEJO de 27 de abril de 2016 (en adelante, “RGPD”) relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos, y la LEY 34/2002, de 11 de julio, de Servicios de la Sociedad de la información y de comercio electrónico (en adelante, “LSSI”), Leal Chapa y Pintura SL informa al usuario que, como responsable del tratamiento, incorporará los datos de carácter personal facilitados por los usuarios en un fichero automatizado.
                  </p>
                  <p>
                    Nuestro compromiso empieza por explicarte lo siguiente:
                  </p>
                  <ul>
                    <li>
                      Se recogen tus datos para que la experiencia de usuario mejore, atendiendo a tus intereses y necesidades.
                    </li>
                    <li>
                      Somos transparentes en relación a los datos que obtenemos acerca de ti y la razón por la que lo hacemos.
                    </li>
                    <li>
                      Nuestra intención es ofrecerte la mejor experiencia posible. Por ello, cuando vayamos a usar tu información personal lo haremos siempre cumpliendo la normativa, y cuando sea necesario, solicitaremos tu consentimiento.
                    </li>
                    <li>
                      Entendemos que tus datos te pertenecen. Por tanto, si decides no autorizarnos a procesarlos puedes solicitarnos que dejemos de tratarlos.
                    </li>
                    <li>
                      Nuestra prioridad consiste en garantizar tu seguridad y tratar tus datos de acuerdo con la normativa europea.
                    </li>
                    <li>
                      Si deseas obtener más información sobre el tratamiento de tus datos, consulta los distintos apartados de la política de privacidad que se encuentran a continuación.
                    </li>
                  </ul>
                  <p>
                    <strong>¿Quién es el responsable del tratamiento de sus datos personales?</strong>
                  </p>
                  <p>Identidad: Leal Chapa y Pintura SL</p>
                  <p>Domicilio social: C/ Congreso, 57 P.I.S.A.</p>
                  <p>C.I.F. nº: B90330242</p>
                  <p>
                    Email:{" "}
                    <a href="mailto:taller@lealchapaypintura.com" target="_blank" rel="noopener noreferrer">
                    taller@lealchapaypintura.com
                    </a>
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU ha designado un Delegado de Protección de Datos o una persona de contacto interna dentro de su organización. Si deseas hacer una consulta en relación al tratamiento de tus datos personales, puedes ponerte en contacto con él mediante el correo{" "}
                    <a href="mailto:taller@lealchapaypintura.com" target="_blank" rel="noopener noreferrer">
                    taller@lealchapaypintura.com
                    </a>
                    .
                  </p>
                  <p>
                    <strong>¿Qué datos personales recopilamos?</strong>
                  </p>
                  <p>Los datos personales que el usuario puede llegar a proporcionar:</p>
                  <ul>
                    <li>Nombre, dirección y fecha de nacimiento.</li>
                    <li>Número de teléfono y dirección de correo electrónico.</li>
                    <li>Ubicación.</li>
                    <li>Información relativa a pagos y devoluciones.</li>
                    <li>
                      Dirección IP, fecha y hora en la que has accedido a nuestros servicios, navegador de internet que uses y datos sobre el sistema operativo del dispositivo.
                    </li>
                    <li>Cualquier otra información o datos que decidas compartir con nosotros.</li>
                  </ul>
                  <p>
                    En algunos casos, es obligatoria la cumplimentación del formulario de registro para acceder y disfrutar de determinados servicios ofrecidos en la web; asimismo, no facilitar los datos personales solicitados o el no aceptar la presente política de protección de datos supone la imposibilidad de suscribirse, registrarse o participar en cualquiera de las promociones en las que se soliciten datos de carácter personal.
                  </p>
                  <p>
                    <strong>¿Por qué y para qué tratamos tus datos?</strong>
                  </p>
                  <p>
                    En Leal Chapa y Pintura SLU tratamos la información que nos facilitan las personas interesadas con las siguientes finalidades:
                  </p>
                  <ul>
                    <li>
                      Gestionar pedidos o contratar alguno de nuestros servicios, ya sea online o en las tiendas físicas.
                    </li>
                    <li>
                      Gestionar el envío de la información que nos soliciten.
                    </li>
                    <li>
                      Desarrollar acciones comerciales y realizar el mantenimiento y gestión de la relación con el usuario, así como la gestión de los servicios ofrecidos a través del sitio web y las labores de información, pudiendo realizar valoraciones automáticas, obtención de perfiles y labores de segmentación de los clientes con el objeto de personalizar el trato conforme a sus características y necesidades y mejorar la experiencia en línea del cliente.
                    </li>
                    <li>
                      Desarrollar y gestionar los concursos, sorteos u otras actividades promocionales que se puedan organizar.
                    </li>
                    <li>
                      En algunos casos será necesario facilitar información a las Autoridades o terceras empresas por motivos de auditoría, así como manejar datos personales de facturas, contratos y documentos para responder a reclamaciones de clientes o de las Administraciones Públicas.
                    </li>
                  </ul>
                  <p>
                    Informamos que los datos personales que se obtengan como consecuencia de tu registro como usuario formarán parte del Registro de Actividades y operaciones de Tratamiento (RAT), que se actualizará periódicamente de acuerdo con lo establecido en el RGPD.
                  </p>
                  <p>
                    <strong>¿Cuál es la legitimación para el tratamiento de tus datos?</strong>
                  </p>
                  <p>
                    El tratamiento de tus datos puede fundamentarse en las siguientes bases legales:
                  </p>
                  <ul>
                    <li>
                      Consentimiento del interesado para la contratación de servicios y productos, para los formularios de contacto, las solicitudes de información o alta en e-newsletters.
                    </li>
                    <li>
                      Interés legítimo para el tratamiento de datos de nuestros clientes en acciones de marketing directo y consentimiento expreso del interesado para todo lo relativo a las valoraciones automáticas y elaboración de perfiles.
                    </li>
                    <li>
                      Cumplimiento de obligaciones legales para prevención del fraude, comunicación con Autoridades públicas y reclamaciones de terceros.
                    </li>
                  </ul>
                  <p>
                    <strong>¿Cuánto tiempo conservamos tus datos?</strong>
                  </p>
                  <p>
                    El tratamiento de los datos con las finalidades descritas se mantendrá durante el tiempo necesario para cumplir con la finalidad de su recogida (por ejemplo, mientras dure la relación comercial), así como para el cumplimiento de las obligaciones legales que se deriven del tratamiento de los datos.
                  </p>
                  <p>
                    <strong>¿A qué destinatarios se comunican tus datos?</strong>
                  </p>
                  <p>
                    En algunos casos, solo cuando sea necesario, Leal Chapa y Pintura SLU proporcionará datos de los usuarios a terceros. Sin embargo, nunca se venderán los datos a terceros. Los proveedores de servicios externos (por ejemplo, proveedores de pago o empresas de reparto) con los que Leal Chapa y Pintura SLU trabaje pueden usar los datos para proporcionar los servicios correspondientes, sin embargo, no usarán dicha información para fines propios o para cesión a terceros.
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU procura garantizar la seguridad de los datos personales cuando se envían fuera de la empresa y se asegura que los terceros proveedores de servicio respeten la confidencialidad y cuenten con las medidas adecuadas para proteger los datos personales. Dichos terceros tienen la obligación de garantizar que la información se trata conforme con la normativa de privacidad de datos. En algunos casos, la ley puede exigir que se revelen datos personales a organismos públicos u otras partes, limitándose la revelación a lo estrictamente necesario para el cumplimiento de dichas obligaciones legales. Los datos personales obtenidos también podrán ser compartidos con otras empresas del grupo.
                  </p>
                  <p>
                    <strong>¿Dónde se almacenan tus datos?</strong>
                  </p>
                  <p>
                    Con carácter general, los datos se almacenan dentro de la UE. Los datos que se envíen a terceros que no pertenezcan a la UE, nos aseguraremos de que ofrezcan un nivel de protección suficiente, ya sea porque cuenten con Normas Corporativas Vinculantes (BCR) o porque se hayan adherido al “Privacy Shield”.
                  </p>
                  <p>
                    <strong>¿Qué derechos te asisten y cómo puedes ejercerlos?</strong>
                  </p>
                  <p>
                    Puedes dirigir tus comunicaciones y ejercitar tus derechos mediante una petición en el siguiente correo electrónico:{" "}
                    <a href="mailto:taller@lealchapaypintura.com" target="_blank" rel="noopener noreferrer">
                    taller@lealchapaypintura.com
                    </a>
                    .
                  </p>
                  <p>
                    En virtud de lo que establece el RGPD puedes solicitar:
                  </p>
                  <ul>
                    <li>
                      <strong>Derecho de acceso:</strong> puedes pedir información de aquellos datos personales que dispongamos acerca de ti.
                    </li>
                    <li>
                      <strong>Derecho de rectificación:</strong> puedes comunicar cualquier cambio en tus datos personales.
                    </li>
                    <li>
                      <strong>Derecho de supresión y al olvido:</strong> puedes solicitar la eliminación previo bloqueo de los datos personales.
                    </li>
                    <li>
                      <strong>Derecho de limitación al tratamiento:</strong> supone la restricción del tratamiento de los datos personales.
                    </li>
                    <li>
                      <strong>Derecho de oposición:</strong> puedes retirar el consentimiento del tratamiento de los datos, oponiéndote a que se sigan tratando.
                    </li>
                    <li>
                      <strong>Derecho a la portabilidad:</strong> en algunos casos, puedes pedir una copia de los datos personales en un formato estructurado, de uso común y lectura mecánica para su transmisión a otro responsable.
                    </li>
                    <li>
                      <strong>Derecho a no ser objeto de decisiones individualizadas:</strong> puedes solicitar que no se tomen decisiones basadas únicamente en el tratamiento automatizado, incluida la elaboración de perfiles, que produzca efectos jurídicos o afecte significativamente al interesado.
                    </li>
                  </ul>
                  <p>
                    En algunos casos, se podrá rechazar la solicitud si se requiere la conservación de datos necesarios para el cumplimiento de obligaciones legales.
                  </p>
                  <p>
                    <strong>¿Quién es el responsable de la exactitud y veracidad de los datos facilitados?</strong>
                  </p>
                  <p>
                    El usuario es el único responsable de la veracidad y corrección de los datos incluidos, exonerando a Leal Chapa y Pintura SLU de cualquier responsabilidad al respecto. Los usuarios garantizan y responden, en cualquier caso, de la exactitud, vigencia y autenticidad de los datos personales facilitados, y se comprometen a mantenerlos debidamente actualizados. El usuario acepta proporcionar información completa y correcta en el formulario de registro o suscripción. Leal Chapa y Pintura SLU se reserva el derecho de finalizar los servicios contratados en caso de que los datos facilitados sean falsos, incompletos, inexactos o no estén actualizados.
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU no responde de la veracidad de las informaciones que no sean de elaboración propia y de las que se indique otra fuente, por lo que tampoco asume responsabilidad alguna por los perjuicios que pudieran derivarse del uso de dicha información.
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU se reserva el derecho a actualizar, modificar o eliminar la información contenida en sus páginas web, pudiendo incluso limitar o no permitir el acceso a dicha información. Se exonera a Leal Chapa y Pintura SLU de responsabilidad ante cualquier daño o perjuicio que pudiera sufrir el usuario como consecuencia de errores, defectos u omisiones en la información facilitada, siempre que ésta provenga de fuentes ajenas.
                  </p>
                  <p>
                    Asimismo, el usuario certifica que es mayor de 14 años y que posee la capacidad legal necesaria para prestar el consentimiento respecto al tratamiento de sus datos personales.
                  </p>
                  <p>
                    <strong>¿Cómo tratamos los datos personales de los menores de edad?</strong>
                  </p>
                  <p>
                    En principio, nuestros servicios no van dirigidos específicamente a menores de edad. Sin embargo, en el supuesto de que alguno de ellos se dirija a menores de catorce años, de conformidad con el artículo 8 del RGPD y el artículo 7 de la LO3/2018 (LOPDGDD), Leal Chapa y Pintura SLU exigirá el consentimiento válido, libre, inequívoco, específico e informado de sus tutores legales para tratar los datos personales de los menores. En este caso, se exigirá el DNI u otra forma de identificación de quien preste el consentimiento.
                  </p>
                  <p>
                    En el caso de mayores de catorce años, podrá proceder al tratamiento de los datos con el consentimiento del usuario, exceptuando aquellos casos en los que la Ley exija la asistencia de los titulares de la patria potestad o tutela.
                  </p>
                  <p>
                    <strong>¿Qué medidas de seguridad aplicamos para proteger tus datos personales?</strong>
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU ha adoptado los niveles de seguridad de protección de los Datos Personales legalmente requeridos y procura instalar medios y medidas técnicas adicionales para evitar la pérdida, mal uso, alteración, acceso no autorizado y robo de los Datos Personales facilitados.
                  </p>
                  <p>
                    Leal Chapa y Pintura SLU no es responsable de daños o perjuicios que se pudieran derivar de interferencias, omisiones, interrupciones, virus informáticos, averías telefónicas o desconexiones en el funcionamiento operativo de este sistema electrónico, motivadas por causas ajenas a la empresa; ni de retrasos o bloqueos en el uso del sistema debido a deficiencias o sobrecargas de líneas telefónicas, en el Centro de Procesos de Datos, en Internet u otros sistemas electrónicos, o de daños causados por terceras personas mediante intromisiones ilegítimas fuera del control de Leal Chapa y Pintura SLU. Sin embargo, el usuario debe ser consciente de que las medidas de seguridad en Internet no son inexpugnables.
                  </p>
                  <p>
                    <strong>Enlaces a otros sitios web</strong>
                  </p>
                  <p>
                    En el sitio web{" "}
                    <a
                      href="http://www.lealchapaypintura.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      www.lealchapaypintura.com
                    </a>{" "}
                    puede haber enlaces a otras páginas web. Al clicar en uno de estos enlaces y acceder a un sitio web externo, la visita estará sujeta a la política de privacidad de dicho sitio, quedando Leal Chapa y Pintura SLU desvinculada de cualquier responsabilidad sobre la misma.
                  </p>
                  <p>
                    <strong>¿Cómo utilizamos las cookies?</strong>
                  </p>
                  <p>
                    El sitio web de Leal Chapa y Pintura SLU utiliza cookies para optimizar y personalizar la navegación. Las cookies son ficheros de información que se alojan en el terminal del usuario, facilitando la navegación y mejorando la experiencia en el portal. Los datos recogidos mediante las cookies pueden ser compartidos con sus creadores, pero nunca se asociarán a datos personales o identificativos del usuario. Si no deseas que se instalen cookies en tu disco duro, puedes configurar tu navegador para impedirlo. Para más información, consulta nuestra{" "}
                    <a
                      href="http://www.lealchapaypintura.com/cookies"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Política de Cookies
                    </a>
                    .
                  </p>
                  <p>
                    <strong>¿Puede modificarse la política de privacidad?</strong>
                  </p>
                  <p>
                    Esta política de privacidad puede modificarse. Te recomendamos revisarla periódicamente.
                  </p>
                </div>
              </div>
              <div className="btn-wrap mt-40">
                <Link to="/" className="btn style2">
                  Volver <i className="fas fa-arrow-left ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
